import React from 'react';
import cx from 'classnames';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
const CONTACT_US = 'https://garysanitary.gov/contact/';
const YOUTUBE = 'https://www.youtube.com/@garysanitarydistrict';
const FACEBOOK = 'https://www.facebook.com/garysanitarydistrict';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          {CONTACT_US && (<a className="footer-link" target="_blank" href={CONTACT_US}>
              Contact Us
            </a>)}
          <a className="footer-link" target="_blank" href={YOUTUBE}>
            <FontAwesomeIcon icon={faYoutube}/>
          </a>
          <a className="footer-link" target="_blank" href={FACEBOOK}>
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
